module.exports = __webpack_public_path__ + "img/al3.7118d60f.png";